import { useEffect, useState, useRef } from 'react'
import API from 'api'
import moment from 'moment'
import Slider from 'react-slick'
import { convertCurrency } from '../helpers/PriceConverter'
import { roundPrice, getKindVerbose } from '../../utils'
import get from 'lodash/get'
import { pushToDataLayer } from 'gtm'
import OperatorCard from './OperatorCard'

export default function SpecialDeals({ eCommerceListName }) {
  const ref = useRef()
  const [deals, setDeals] = useState([])
  useEffect(function() {
    API(`promotions/best-deals/`)
      .get()
      .then((data) => {
        const { results } = data
        results.forEach((operator, index) => {
          const { promotion, shopTitle, dateFrom, dateTo } = operator
          operator.impression = {
            name: shopTitle,
            id: operator.shopId,
            price: roundPrice(
              convertCurrency(operator.price, operator.currency, 'USD')
            ),
            brand: `${shopTitle}|${
              operator.affiliateId || 'Non-PADI Operator'
            }`,
            category: getKindVerbose(operator.shopKind),
            variant: `${promotion ? promotion.title : 'Deals'} / ${moment(
              dateFrom
            ).format('DD MMM')} - ${moment(dateTo).format('DD MMM')}`,
            list: eCommerceListName,
            position: index + 1,
          }
        })
        setDeals(results)
      })
  }, [])

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    dots: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      {
        breakpoint: 769,
        settings: { slidesToShow: 2.5, slidesToScroll: 1, arrows: false },
      },
      {
        breakpoint: 481,
        settings: { slidesToShow: 1.2, slidesToScroll: 1, arrows: false },
      },
    ],
    beforeChange: (a, b) => {
      const difference = b + Math.abs(a - b)
      pushToDataLayer({
        event: 'impression',
        ecommerce: {
          currencyCode: 'USD',
          impressions: deals
            .slice(b, difference)
            .map((item) => item.impression),
        },
      })
    },
  }

  useEffect(() => {
    const numberOfItemsToShow = get(
      ref,
      'current.innerSlider.props.slidesToShow'
    )
    if(numberOfItemsToShow && deals.length) {
      pushToDataLayer({
        event: 'impression',
        ecommerce: {
          currencyCode: 'USD',
          impressions: deals
            .slice(0, numberOfItemsToShow)
            .map((item) => item.impression),
        },
      })
    }
  }, [ref.current, deals.length])

  return (
    <Slider
      ref={ref}
      className='slick-pt-custom space-between same-height'
      {...settings}
    >
      {deals.map((shop, index) => {
        const handleClick = () => {
          if(shop.impression) {
            window.dataLayer.push({
              event: 'productClick',
              ecommerce: {
                currencyCode: 'USD',
                click: {
                  actionField: {
                    list: eCommerceListName,
                  },
                  products: [shop.impression],
                },
              },
            })
          }
        }
        return <OperatorCard shop={shop} handleClick={handleClick} key={shop.shopId + index} />
      })}
    </Slider>
  )
}
